__turbopack_context__.v({
  "socialButton": "SocialButton-module-scss-module__69ugoa__socialButton",
});
